import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { CalendarEvent } from '../../@types/api';
import { eventTypeDescription } from '../../Constants';
import Room from '@mui/icons-material/Room';
import BusinessIcon from '@mui/icons-material/Business';
import LinkIcon from '@mui/icons-material/Link';
import Notes from '@mui/icons-material/Notes';
import EventIcon from '@mui/icons-material/Event';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import DescriptionIcon from '@mui/icons-material/Description';
import BookIcon from '@mui/icons-material/Book';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import DateRangeIcon from '@mui/icons-material/DateRange';
import dayjs from 'dayjs';

const boxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
};

interface Props {
  selectedEvent: CalendarEvent | undefined;
  deleteEvent: () => void;
  setSelectedEvent: (event: CalendarEvent | undefined) => void;
}
const ViewEventDialogue: React.FC<Props> = ({
  selectedEvent,
  deleteEvent,
  setSelectedEvent,
}) => {
  return (
    <Dialog open={!!selectedEvent}>
      <DialogTitle>{selectedEvent?.artistName}</DialogTitle>
      <DialogContent>
        <Box sx={{ minWidth: '330px' }}>
          {selectedEvent?.bookingId && selectedEvent?.bookingId > 0 ? (
            <Box {...boxProps}>
              <BookIcon />
              <Box sx={{ ml: 2 }}>BookingID: {selectedEvent.bookingId}</Box>
            </Box>
          ) : null}
          {selectedEvent?.description && (
            <Box {...boxProps}>
              <DescriptionIcon />
              <Box sx={{ ml: 2 }}>Description: {selectedEvent.description}</Box>
            </Box>
          )}
          <Box {...boxProps}>
            <DateRangeIcon />
            <Box sx={{ ml: 2 }}>
              Date: {dayjs(selectedEvent?.startDate).format('DD MMM YYYY')}
            </Box>
          </Box>
          <Box {...boxProps}>
            <AccessTimeIcon />
            <Box sx={{ ml: 2 }}>
              Time: {dayjs(selectedEvent?.start).format('HH:mm A')} -{' '}
              {dayjs(selectedEvent?.end).format('HH:mm A')}
            </Box>
          </Box>
          {selectedEvent?.eventTypeId && (
            <Box {...boxProps}>
              <EventIcon />
              <Box sx={{ ml: 2 }}>
                Type:{' '}
                {
                  eventTypeDescription[
                    selectedEvent?.eventTypeId as keyof typeof eventTypeDescription
                  ]
                }
              </Box>
            </Box>
          )}
          {selectedEvent?.venue && (
            <Box {...boxProps}>
              <BusinessIcon />
              <Box sx={{ ml: 2 }}>Venue: {selectedEvent.venue}</Box>
            </Box>
          )}
          {selectedEvent?.location && (
            <Box {...boxProps}>
              <Room />{' '}
              <Box sx={{ ml: 2 }}>Location: {selectedEvent.location}</Box>
            </Box>
          )}
          {selectedEvent?.clientName && (
            <Box {...boxProps}>
              <PersonIcon />{' '}
              <Box sx={{ ml: 2 }}>Client: {selectedEvent.clientName}</Box>
            </Box>
          )}
          {selectedEvent?.telephone && (
            <Box {...boxProps}>
              <CallIcon />{' '}
              <Box sx={{ ml: 2 }}>Tel: {selectedEvent.telephone}</Box>
            </Box>
          )}
          {selectedEvent?.emailAddress && (
            <Box {...boxProps}>
              <EmailIcon />{' '}
              <Box sx={{ ml: 2 }}>Email: {selectedEvent.emailAddress}</Box>
            </Box>
          )}
          {selectedEvent?.comments && (
            <>
              <Box {...boxProps}>
                <ModeCommentIcon />
                <Box sx={{ ml: 2 }}>{selectedEvent.comments}</Box>
              </Box>
            </>
          )}
          {selectedEvent?.link && (
            <Box {...boxProps}>
              <LinkIcon />
              <Box sx={{ ml: 2 }}>
                <a
                  href={selectedEvent?.link}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Tickets Link
                </a>
              </Box>
            </Box>
          )}
          {selectedEvent?.ticketDetail && (
            <Box {...boxProps}>
              <Notes />
              <Box sx={{ ml: 2 }}>
                TicketDetail: {selectedEvent.ticketDetail}
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        {selectedEvent && selectedEvent.eventTypeId >= 5 && (
          <Button
            onClick={deleteEvent}
            color='error'
            variant='contained'
            size='small'
          >
            Delete
          </Button>
        )}
        <Button
          onClick={() => setSelectedEvent(undefined)}
          color='primary'
          variant='outlined'
          size='small'
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewEventDialogue;
